import React, { useState, useEffect } from "react"
import styled from "styled-components"
import FirstFloor from "./first/FirstFloor"
import Table from "./first/table/Table"
import { liveBetsCounter } from "./helpers/countLiveBets"

export default function ToggleStats({
  users,
  footerState,
  showStat,
  handleToggleStats,
}: any) {
  const [liveBets, setliveBets] = useState(0)
  useEffect(() => {
    setliveBets(liveBetsCounter(users))
  }, [users])

  return (
    <StyledToogle footerState={footerState !== "ending"} show={showStat}>
      <FirstFloor
        show={showStat}
        handleToggle={handleToggleStats}
        betsAmount={liveBets}
      />
      <Table users={users} />
    </StyledToogle>
  )
}

export const StyledToogle = styled.div<{ footerState: boolean; show: boolean }>`
  display: ${({ footerState }) => (footerState ? "block" : "none")};
  height: ${({ show }) => (show ? "330px" : "40px")};
  overflow: hidden;
  transition: all 0.3s;
  background: rgba(48, 30, 86, 0.85);
  border-radius: 20px 20px 0 0;
`
